import { useAuthStore } from '@/store/auth';
import { useRouter } from 'next/navigation';

export const useSocialSignIn = () => {
  const setToken = useAuthStore((state) => state.setToken);
  const setUser = useAuthStore((state) => state.setUser);
  const setRefreshToken = useAuthStore((state) => state.setRefreshToken);
  const router = useRouter();

  const handleSocialSignIn = (provider: 'google' | 'linkedin') => {
    window.location.href = `${process.env.NEXT_PUBLIC_API_BASE_URL}/v1/api/auth/${provider}`;
  };

  const handleSocialAuthSuccess = (query: URLSearchParams) => {
    const accessToken = query.get('accessToken');
    const refreshToken = query.get('refreshToken');
    const email = query.get('email');
    const fullName = query.get('fullName');
    const userName = query.get('userName');
    const tenantId = query.get('tenantId');
    const id = query.get('id');
    const areaOfInterest = query.get('areaOfInterest');
    const profilePicture = query.get('profilePicture');

    if (!accessToken || !email) {
      router.push('/sign-in');
      return;
    }

    if (refreshToken) {
      setRefreshToken(refreshToken);
    }

    if (accessToken && email) {
      setToken(accessToken);
      setUser({
        id: id ?? '',
        email,
        isVerified: true,
        status: 'active',
        tenantId: tenantId || '',
        fullName: fullName || null,
        userName: userName || null,
        areaOfInterest: areaOfInterest ? [areaOfInterest] : null,
        profilePicture: profilePicture || null,
      });

      if (!userName) router.replace('/profile-setup');
      else router.replace('/home');
    }
  };

  return { handleSocialSignIn, handleSocialAuthSuccess };
};
